export default "__VITE_ASSET__BRC6fCjx__"